import React, { useEffect, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { capitalizeFirstLetter } from './utils';

const AttachRateTable = ({ results, userDetail }) => {
  const [isScrolling, setIsScrolling] = useState(false);


  const headers = [
    { key: 'Act', label: 'Activation' },
    { key: 'AA', label: 'Accessories Attached' },
    { key: 'AR', label: 'Attach Rate' },
    { key: 'Disc', label: 'Discount' },
    ...(userDetail?.role === 'admin' ? [{ key: 'PM', label: 'Profit Margin' }] : []),
    { key: 'AccQty', label: 'Accessory Quantity' },
    { key: 'AAA', label: 'Accessory Quantity per Activation' },
    { key: 'PPP', label: 'Phone Protection Plan' },
    { key: 'PPPAtt', label: 'Phone Protection Plan Attach' },
    { key: 'WD', label: 'With Device' },
    { key: 'WDAtt', label: 'With Device Attach' },
    { key: 'HRS', label: 'Hours' },
    { key: 'AH', label: 'Activity Per Hour' },
    { key: 'Rev', label: 'Revenue' },
    { key: 'RH', label: 'Revenue Per Hour' },
  ];

  const headersbot = [
    { key: 'Hup', label: 'Hardware Upgrade' },
    { key: 'AA', label: 'Accessories Attached' },
    { key: 'AR', label: 'Attach Rate' },
    { key: 'Disc', label: 'Discount' },
    ...(userDetail?.role === 'admin' ? [{ key: 'PM', label: 'Profit Margin' }] : []),
    { key: 'AccQty', label: 'Accessory Quantity' },
    { key: 'AAA', label: 'Accessory Quantity per HUP' },
    { key: 'PPP', label: 'Phone Protection Plan' },
    { key: 'PPPAtt', label: 'Phone Protection Plan Attach' },
    { key: 'OA No', label: 'Only Accesorries' },
    ...(userDetail?.role === 'admin'
      ? [{ key: 'OA PM', label: 'Only Accesorries Profit Margin' }]
      : []),
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolling(true);

      // Set a timeout to reset scrolling state after the scroll ends
      setTimeout(() => {
        setIsScrolling(false);
      }, 3000); // Adjust the delay as necessary
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={`table ${results?.length === 1 ? 'single-table' : ''}`}>
      {results.map(([name, detail], index) => (
        <div className="table-container" key={index}>
          <div className="emp">
            <span>{capitalizeFirstLetter(name,userDetail)}</span>
          </div>
          <div className="emp-table">
            <div className="table-act">
              <p>Activations</p>
              <table className="professional-table">
                <thead>
                  <tr>
                    {headers.map((header, index) => (
                      <Tooltip
                        key={index}
                        title={isScrolling ? '' : `${header.label}`}
                        arrow
                        placement="top"
                      >
                        <th>{header.key}</th>
                      </Tooltip>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{detail?.act}</td>
                    <td>{detail?.actCount}</td>
                    <td>{detail?.act === 0 ? 0 : detail?.actARate?.toFixed(2)}%</td>
                    <td>${detail?.actSum?.discount?.toFixed(2)}</td>
                    {userDetail?.role === 'admin' ? <td>${detail?.actPm?.toFixed(2)}</td> : ''}
                    <td>{detail?.accActNumber}</td>
                    <td>{detail?.act === 0 ? 0 : detail?.accActNumRate?.toFixed(2) || 0}</td>
                    <td>{detail?.actPPP}</td>
                    <td>{detail?.act === 0 ? 0 : detail?.actPPPRate?.toFixed(2) || 0}%</td>
                    <td>{detail?.actWD}</td>
                    <td>{detail?.act === 0 ? 0 : detail?.actWDRate?.toFixed(2)}%</td>
                    <td>{typeof detail?.hours === 'number' ? detail.hours.toFixed(2) : 0.00}</td>
                    <td>{detail?.actperH?.toFixed(2) || 0.00}</td>
                    <td>${detail?.OAplusComm?.toFixed(2)}</td>
                    <td style={{ backgroundColor: 'yellow' }}>
                      $
                      {detail?.OAPlusrevperH && isFinite(detail?.OAPlusrevperH)
                        ? detail?.OAPlusrevperH?.toFixed(2)
                        : 0}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="table-hup">
              <p>Hardware Update</p>
              <table className="professional-table">
                <thead>
                  <tr>
                    {headersbot.map((header, index) => (
                      <Tooltip
                        key={index}
                        title={isScrolling ? '' : `${header.label}`}
                        arrow
                        placement="top"
                      >
                        <th>{header.key}</th>
                      </Tooltip>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{detail?.hup}</td>
                    <td>{detail?.hupCount}</td>
                    <td>{detail?.hup === 0 ? 0 : detail?.hupARate?.toFixed(2)}%</td>
                    <td>${detail?.hupSum?.discount?.toFixed(2)}</td>
                    {userDetail?.role === 'admin' ? <td>${detail?.hupPm?.toFixed(2)}</td> : ''}
                    <td>{detail?.accHupNumber}</td>
                    <td>{detail?.hup === 0 ? 0 : detail?.accHupNumRate?.toFixed(2)}</td>
                    <td>{detail?.hupPPP}</td>
                    <td>{detail?.hup === 0 ? 0 : detail?.hupPPPRate?.toFixed(2)}%</td>
                    <td>{detail?.OAtotal ? detail?.OAtotal : 0}</td>
                    {userDetail?.role === 'admin' ? (
                      <td>${detail?.OAPM ? detail?.OAPM?.toFixed(2) : 0}</td>
                    ) : (
                      ''
                    )}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AttachRateTable;
